import { AuthGuardService } from '../services/auth-guard.service';

import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SalesReportComponent } from './sales.report/sales.report.component';
import { SalesProductSettingsComponent } from './sales.product.settings/sales.product.settings.component';

const SalesRouting: Routes = [
    // login view
    {

        path: 'sales', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: '', component: SalesReportComponent },
            { path: 'reports', component: SalesReportComponent },
            { path: 'product-settings', component: SalesProductSettingsComponent },
			// handle all other routes
            { path: '**', component: SalesReportComponent }
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(SalesRouting)],
    exports: [RouterModule]
})
export class SalesRoutingModule { }
